export default {
  save: 'Zapisz',
  cancel: 'Anuluj',
  ok: 'OK',
  confirm: 'Potwierdź',
  information: 'Informacje',
  confirm_delete: 'Czy na pewno chcesz usunąć tę cechę? Nie można tego cofnąć.',
  invalid_geometry: 'Nieprawidłowa geometria',
  no_results: 'Brak wyników dla tego wyszukiwania',
  invalid_lat_long_range:
    'Nieprawidłowe współrzędne: Wartości szerokości i długości geograficznej muszą mieścić się w dozwolonych zakresach.',
  invalid_lat_lon:
    'Podane współrzędne nie mieszczą się w wybranej lokalizacji.',
  remove_last_vertex: 'Usuń ostatni wierzchołek',
  delete: 'Usuń',
  delete_vertex: 'Usuń wierzchołek',
  draw_dialog_title: 'Instrukcje rysowania',
  draw_dialog_begin_drawing:
    'Rozpocznij rysowanie - Kliknij gdziekolwiek na mapie',
  draw_dialog_cancel_drawing: 'Anuluj rysowanie - Klawisz ESC',
  draw_dialog_remove_vertex:
    'Usuń ostatni wierzchołek - Kliknij prawym przyciskiem myszy',
  draw_dialog_save: 'Zapisz - Podwójne kliknięcie',
  draw_dialog_save_single: 'Zapisz - Pojedyncze kliknięcie',
  draw_point: 'Punkt',
  draw_position: 'Bieżąca pozycja',
  draw_polygon: 'Wielokąt',
  draw_rectangle: 'Prostokąt',
  circle_config: 'Konfiguracja okręgu',
  draw_circle: 'Okrąg z centrum',
  draw_circle_2pt: 'Okrąg ręczny',
  radius: 'Promień',
  units: 'Jednostki',
  draw_line: 'Linia',
  dark_mode: 'Kolorystyka',
  create: 'Utwórz',
  icon_scaling_field: 'Przełącz skalowanie ikon pola',
  icon_scaling_label: 'Skala ikony',
  icon_scaling_cluster: 'Skala ikony grupy',
  icon_scaling_cluster_log: 'Skala logarytmiczna grupy',
  icon_scaling_zoom_in: 'Skala powiększenia',
  icon_scaling_zoom_out: 'Skala pomniejszenia',
  pill_component_remove: 'Usuń',
  no_data_filter: 'To pole nie zawiera danych i nie można go filtrować.',
  filter_searchbox_placeholder: 'Szukaj',
  identical_values_filter:
    'To pole zawiera tylko jedną unikalną wartość i nie można go filtrować.',
  layer_group_hide_layers: 'Ukryj wszystkie warstwy w grupie',
  layer_zoom_to_extent: 'Powiększ do obszaru filtrowanej warstwy',
  layer_visibility: 'Przełącz widoczność',
  zoom_to: 'Powiększ do',
  layer_dataview_header: 'Widoki danych',
  layer_add_new_location: 'Dodaj nowe lokalizacje',
  layer_filter_header: 'Filtr',
  layer_filter_select: 'Wybierz filtr z listy',
  layer_filter_clear_all: 'Wyczyść wszystkie filtry',
  layer_filter_reset_all: 'Zresetuj wszystkie filtry',
  layer_filter_greater_than: 'Większe niż',
  layer_filter_less_than: 'Mniejsze niż',
  layer_filter_set_filter: 'Ustaw filtr',
  layer_style_header: 'Styl',
  layer_style_select_theme: 'Wybierz styl tematyczny',
  layer_style_display_labels: 'Wyświetl etykiety',
  layer_style_display_hover: 'Włącz podświetlenie',
  layer_style_switch_caption:
    'Kliknij na etykiety, aby przełączyć widoczność lub',
  layer_style_switch_all: 'przełącz wszystko',
  layer_grid_legend_ratio: 'Wyświetl kolor jako stosunek do rozmiaru',
  layer_style_cluster: 'Wiele lokalizacji',
  layer_style_opacity: 'Zmień przezroczystość warstwy:',
  location_clear_all: 'Wyczyść lokalizacje',
  location_listview_full: 'Widok listy dla lokalizacji jest pełny.',
  location_zoom: 'Powiększ mapę do granic cechy',
  location_save: 'Zapisz zmiany w chmurze',
  location_remove: 'Usuń cechę z wyboru',
  location_delete: 'Usuń lokalizację',
  location_save_changes: 'Czy chcesz zapisać zmiany w tej lokalizacji?',
  location_close_without_save: 'Zamknąć lokalizację bez zapisywania zmian?',
  image_upload_failed: 'Wysyłanie obrazu nie powiodło się.',
  document_upload_failed: 'Wysyłanie dokumentu nie powiodło się.',
  remove_image_confirm:
    'Czy na pewno chcesz usunąć obraz? Nie można tego cofnąć.',
  remove_document_confirm:
    'Czy na pewno chcesz usunąć ten dokument? Nie można tego cofnąć.',
  remove_item_confirm: 'Usuń element?',
  delete_geometry: 'Usuń geometrię',
  modify_geometry: 'Zmień geometrię',
  edit_dialog_title: 'Instrukcje edycji',
  edit_dialog_cancel_drawing:
    'Anuluj rysowanie - Kliknij przycisk anulowania, aby anulować rysowanie.',
  edit_dialog_remove_vertex:
    'Usuń wierzchołek - Kliknij na wierzchołek, aby go usunąć.',
  edit_dialog_modify_shape:
    'Edytuj kształt - Przeciągnij wierzchołek, aby zmodyfikować kształt lub dodaj nowy wierzchołek do wielokąta.',
  edit_dialog_save: 'Zapisz - Kliknij przycisk zapisu, aby zapisać zmiany.',
  report: 'Raport',
  link: 'Link',
  pin: 'Przypnij',
  loading: 'Ładowanie',
  no_options_available: 'Brak dostępnych opcji.',
  toolbar_zoom_in: 'Powiększ',
  toolbar_zoom_out: 'Pomniejsz',
  toolbar_zoom_to_area: 'Powiększ do obszaru',
  toolbar_current_location: 'Bieżąca lokalizacja',
  toolbar_fullscreen: 'Pełny ekran mapy',
  toolbar_admin: 'Otwórz widok administracyjny konta',
  toolbar_login: 'Zaloguj się',
  toolbar_logout: 'Wyloguj się',
  layers: 'Warstwy',
  locations: 'Lokalizacje',
  no_locales:
    'Twoje konto zostało zweryfikowane i zatwierdzone, ale nie masz dostępu do żadnych lokalizacji. Prawdopodobnie jest to spowodowane tym, że administrator nie przyznał Ci wymaganych ról. Skontaktuj się z administratorem, aby rozwiązać ten problem.',
  no_layers: 'Brak dostępnych warstw w lokalizacji.',
};
